import i18n from "@/i18n";
import type { Field } from "@/warRoom/datasets/types";
import { tr } from "@/warRoom/lib/i18n";

const nf = new Intl.NumberFormat("zh-TW");
const cf = new Intl.NumberFormat("zh-TW", {
  style: "currency",
  currency: "TWD",
  maximumFractionDigits: 0,
});
const compact = new Intl.NumberFormat("en", {
  notation: "compact",
  maximumFractionDigits: 1,
});

const PLACEHOLDER_KEY: Record<string, string> = {
  "（無）": "warRoom.common.none",
  "（未填）": "warRoom.common.notFilled",
  "（未命名）": "warRoom.common.unnamed",
  "（未分類）": "warRoom.common.uncategorized",
};

export function formatValue(value: number, format?: Field["format"]): string {
  if (!Number.isFinite(value)) return "—";
  switch (format) {
    case "currency":
      return cf.format(value);
    case "decimal":
      return nf.format(Math.round(value * 100) / 100);
    default:
      return nf.format(Math.round(value * 100) / 100);
  }
}

/** 軸刻度用的短標籤：12,345,678 → 1,235萬 */
export function formatAxis(value: number, format?: Field["format"]): string {
  if (!Number.isFinite(value)) return "";
  const abs = Math.abs(value);
  if (format === "currency" || abs >= 10000) {
    if (!i18n.language?.startsWith("zh") && abs >= 1e4)
      return compact.format(value);
    if (abs >= 1e8) return `${nf.format(Math.round(value / 1e7) / 10)}億`;
    if (abs >= 1e4) return `${nf.format(Math.round(value / 1e3) / 10)}萬`;
  }
  return nf.format(Math.round(value * 100) / 100);
}

/** dimension 的顯示標籤（套 enum 中文對照） */
export function labelOf(field: Field | undefined, raw: unknown): string {
  if (raw === null || raw === undefined || raw === "")
    return tr("warRoom.common.noData");
  const key = String(raw);
  const placeholder = PLACEHOLDER_KEY[key];
  return field?.enumLabels?.[key] ?? (placeholder ? tr(placeholder) : key);
}
